<template>
  <section class="experience-section">
    <div class="experience-container">
      <div class="experience-header">
        <h2 class="section-title">The Brewtopia Experience</h2>
        <p class="section-subtitle">More than just coffee</p>
      </div>

      <div class="gallery-grid">
        <div 
          v-for="(item, index) in galleryItems" 
          :key="index"
          :class="['gallery-item', item.size]"
          ref="galleryItems">
          <img :src="item.image" :alt="item.alt" loading="lazy">
          <div class="gallery-overlay">
            <span class="overlay-text">{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ExperienceGallery',
  data() {
    return {
      galleryItems: [
        {
          image: '/Images/clifford-VobvKmG-StA-unsplash.jpg',
          alt: 'Cafe Interior',
          text: 'Our Space',
          size: 'large-1'
        },
        {
         image: '/Images/armin-lotfi-gURxlcD9I0U-unsplash.jpg',
          alt: 'Latte Art',
          text: 'Crafted With Love',
          size: 'medium-1'
        },
        {
        image: '/Images/pexels-pavel-danilyuk-5788197.jpg',
          alt: 'Customer Enjoying Coffee',
          text: 'Your Moment',
          size: 'large-2'
        },
        {
        image: '/Images/stefan-k-PzJslB7ds_Y-unsplash.jpg',
          alt: 'Pastries Display',
          text: 'Fresh Baked',
          size: 'medium-2'
        },
        {
          image: '/Images/pexels-myfoodie-2648988.jpg',
          alt: 'Coffee on Table',
          text: 'Perfect Blend',
          size: 'medium-3'
        },
        {
          image: '/Images/pexels-pavel-danilyuk-6612643.jpg',
          alt: 'Coffee Table Scene',
          text: 'Cozy Vibes',
          size: 'medium-4'
        },
        {
          image: '/Images/pexels-chevanon-312418.jpg',
          alt: 'Latte Art Close',
          text: 'Artisan Coffee',
          size: 'medium-5'
        },
        {
          image: '/Images/alex-lvrs-Z9KCFiro0eM-unsplash.jpg',
          alt: 'Exterior Night',
          text: 'Day & Night',
          size: 'large-3'
        }
      ]
    }
  },
  mounted() {
    this.observeSection();
  },
  methods: {
    observeSection() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.2
      });

      this.$refs.galleryItems.forEach((item) => {
        observer.observe(item);
      });
    }
  }
}
</script>

<style scoped>
.experience-section {
  width: 100%;
  padding: 6rem 2rem;
  background-color: #FFF8DC;
}

.experience-container {
  max-width: 1200px;
  margin: 0 auto;
}

.experience-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 600;
  color: #6F4E37;
  margin-bottom: 0.5rem;
}

.section-subtitle {
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  color: #8B7355;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(10, 1fr); /* زودت من 6 إلى 10 عشان الصور تكبر */
  gap: 1rem;
  height: 900px; /* زودت من 700px إلى 900px */
}

.gallery-item {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.gallery-item.visible {
  opacity: 1;
  transform: scale(1);
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.gallery-item:hover img {
  transform: scale(1.1);
}

.gallery-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(111, 78, 55, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.gallery-item:hover .gallery-overlay {
  opacity: 1;
}

.overlay-text {
  font-family: 'Playfair Display', serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: #FFF8DC;
}

/* Grid Layout */
/* العمود الأول - 3 صور */
.large-1 {
  grid-column: 1 / 3;
  grid-row: 1 / 5;  /* 4 صفوف - الصورة الكبيرة */
}

.medium-2 {
  grid-column: 1 / 3;
  grid-row: 5 / 8;  /* 3 صفوف */
}

.medium-4 {
  grid-column: 1 / 3;
  grid-row: 8 / 11; /* 3 صفوف */
}

/* العمود الثاني - 3 صور */
.medium-1 {
  grid-column: 3 / 5;
  grid-row: 1 / 4;  /* 3 صفوف */
}

.medium-3 {
  grid-column: 3 / 5;
  grid-row: 4 / 7;  /* 3 صفوف */
}

.medium-5 {
  grid-column: 3 / 5;
  grid-row: 7 / 11; /* 4 صفوف */
}

/* العمود الثالث - 2 صور */
.large-2 {
  grid-column: 5 / 7;
  grid-row: 1 / 6;  /* 5 صفوف */
}

.large-3 {
  grid-column: 5 / 7;
  grid-row: 6 / 11; /* 5 صفوف */
}

/* Responsive */
@media (max-width: 1024px) {
  .gallery-grid {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    height: auto;
    grid-auto-rows: 180px;
  }

  .large-1 {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
  }

  .medium-1 {
    grid-column: 3 / 5;
    grid-row: 1 / 2;
  }

  .large-2 {
    grid-column: 3 / 5;
    grid-row: 2 / 4;
  }

  .medium-2 {
    grid-column: 1 / 3;
    grid-row: 3 / 4;
  }

  .medium-3 {
    grid-column: 1 / 3;
    grid-row: 4 / 5;
  }

  .medium-4 {
    grid-column: 3 / 5;
    grid-row: 4 / 5;
  }

  .medium-5 {
    grid-column: 1 / 3;
    grid-row: 5 / 6;
  }

  .large-3 {
    grid-column: 3 / 5;
    grid-row: 5 / 7;
  }
}

@media (max-width: 768px) {
  .experience-section {
    padding: 4rem 1.5rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 180px;
    gap: 0.75rem;
  }

  .gallery-item {
    grid-column: span 1 !important;
    grid-row: span 1 !important;
  }
}
</style>